import { DamageType, MileageUnit, VehiclePart } from '@monkvision/types';

export enum TeslaModel {
  MODEL_S = 'Model S',
  MODEL_3 = 'Model 3',
  MODEL_X = 'Model X',
  MODEL_Y = 'Model Y',
}

export const TeslaModelAbbreviation = {
  [TeslaModel.MODEL_S]: 'S',
  [TeslaModel.MODEL_3]: '3',
  [TeslaModel.MODEL_X]: 'X',
  [TeslaModel.MODEL_Y]: 'Y',
};

export enum TeslaCountry {
  UK = 'UK',
  NL = 'NL',
  FR = 'FR',
  US = 'US',
  DE = 'DE',
  CH_DE = 'CH_DE',
  CH_FR = 'CH_FR',
  CH_IT = 'CH_IT',
  IT = 'IT',
  AU = 'AU',
}

export enum TeslaInspectionStatus {
  INSPECTION_LINK_SEND = 'inspection_link_send',
  ONGOING_CAPTURE = 'ongoing_capture',
  READY_FOR_REVIEW = 'ready_for_review',
  PDF_SENT = 'pdf_sent',
  FINALIZED = 'finalized',
}

export enum OwnershipFilter {
  OWN_RESOURCES = 'own_resources',
  ORGANIZATION_RESOURCES = 'organization_resources',
  ALL_RESOURCES = 'all_resources',
}

export enum InspectionType {
  LEASE_RETURN = 'lease_return',
  TRADE_IN = 'trade_in',
}

export const INSPECTION_TYPE_KEYS = {
  [InspectionType.LEASE_RETURN]: 'drawer.leaseReturn',
  [InspectionType.TRADE_IN]: 'drawer.tradeIn',
};

export interface TeslaDeductionDetails {
  part: VehiclePart;
  pricing: number;
  damages: DamageType[];
}

export interface TeslaInteriorDamages {
  area: string;
  damages: string;
  pricing: number;
}

export interface TeslaInspection {
  inspectionId: string;
  status?: TeslaInspectionStatus;
  vin?: string;
  make?: string;
  model?: TeslaModel;
  lastUpdated?: Date;
  leaseMaturityDate?: Date;
  country: TeslaCountry;
  licencePlate?: string;
  odometer?: number;
  totalPricing?: number;
  deductionDetails?: TeslaDeductionDetails[];
  interiorDamages?: TeslaInteriorDamages[];
  originalDeductionDetails?: TeslaDeductionDetails[];
  pdfUrl?: string;
  inspectionStart?: Date;
  inspectionEnd?: Date;
  mileageUnit?: MileageUnit;
  inspectionType?: InspectionType;
}

export interface Pagination {
  rowsPerPage: number;
  start: number;
  end: number;
  totalItems: number;
}
